import angular from 'angular';
import forEach from 'lodash/forEach';
import find from 'lodash/find';
import cloneDeep from 'lodash/cloneDeep';

class JsonBuilderService {
    constructor(config, windowDimensionsService, apiService) {
        this.config = config;
        this.windowDimensionsService = windowDimensionsService;
        this.apiService = apiService;

        this.data = [];
        this.orginalData = [];
    }

    setInitialData(data) {
        this.orginalData = data;
        this.data = cloneDeep(data);
        this.standardFields = data.data[0].attributes.standardFields;
        this.topLightFields = data.data[0].attributes.topLightFields;
    }

    convertSashTypes(sashTypes, isLeft, sashNumber) {
        const oneHingeSideContidion = (this.standardFields === 1 && sashNumber === 0);
        const threeHingeSideContidion = (this.standardFields === 3 && sashNumber === 1) &&
            (sashTypes[0] === 'DK' && sashTypes[1] === 'DK' && sashTypes[2] === 'DK');
        const functionLetter = sashTypes[sashNumber];
        const notFixedSash = functionLetter === 'DK' || functionLetter === 'K';
        const fixedSash = functionLetter === 'F' || functionLetter === 'FF';
        const fixOptionId = this.getInitialValueId('fixOption');

        if (this.data.data[0].type === 'folding_door' && this.getInitialOptions('sash')[sashNumber].attributes.handleSide) {
            return {
                handlePosition: this.getInitialOptions('sash')[sashNumber].attributes.handleSide,
                type: functionLetter,
            };
        }

        if (oneHingeSideContidion && notFixedSash && this.topLightFields === 0) {
            const initialSide = this.getInitialValueId('hingeSide');
            let position = 'L';
            if (initialSide === '2') {
                position = 'R';
            } else if (initialSide === '3') {
                position = 'T';
            }

            return {
                id: this.config.sashTypes[functionLetter][position],
                handlePosition: position,
                type: functionLetter
            };
        }
        if (threeHingeSideContidion && this.topLightFields === 0) {
            const initialSide = this.getInitialValueId('hingeSide');
            return {
                // id: this.config.sashTypes.DS[initialSide === '2' ? 'R' : 'L'],
                id: this.config.sashTypes[functionLetter][initialSide === '2' ? 'R' : 'L'],
                handlePosition: initialSide === '2' ? 'R' : 'L',
                type: functionLetter
                    // type: 'DS'
            };
        }
        if (fixedSash && fixOptionId === '1') {
            return {
                id: this.config.sashTypes.F,
                handlePosition: null,
                type: 'F'
            };
        }
        if (fixedSash && fixOptionId === '2') {
            return {
                id: this.config.sashTypes.FF,
                handlePosition: null,
                type: 'FF'
            };
        }

        const handleSide = this.getInitialOptions('sash')[sashNumber].attributes.handleSide;
        return {
            // id: this.config.sashTypes[functionLetter][isLeft ? 'L' : 'R'],
            handlePosition: handleSide,
            type: functionLetter
        };
    }

    getInitialApiObject() {
        const apiData = this.data.data[0];
        let apiObject = {
            title: apiData.attributes.name,
            type: apiData.type,
            system: parseInt(this.getInitialValueId('line'), 10),
            width: this.getInitialAttributes('width'),
            height: this.getInitialAttributes('height')
        };
        apiObject = Object.assign(this.config.jsonConfig.default, apiObject);
        this.getInitialColors(apiObject);
        apiObject.accessories = this.getInitialAccesories();
        apiObject.sealColor = this.getInitialSealColor();
        this.setInitialSashesAndDividers(apiObject);
        apiObject.muntins = this.getInitialMuntins();
        apiObject.shape = Object.assign(this.config.jsonConfig.shape, this.getInititialShape());
        apiObject.usedProfiles = this.getInitialAttributes('usedProfiles');
        this.setInitialDividerUsedProfiles(apiObject);

        return cloneDeep(apiObject);
    }

    setInitialDividerUsedProfiles(apiObject) {
        const apiObj = apiObject;
        const dividersSizes = this.getInitialOptions('dividerSize');
        const id = this.getInitialValueId('dividerSize');
        let initialDividerSize = find(dividersSizes, el => el.id === id.toString());

        if (!initialDividerSize) {
            initialDividerSize = dividersSizes[0];
        }
        if (angular.isDefined(initialDividerSize)) {
            if (apiObj.usedProfiles.length === 4) {
                apiObj.usedProfiles.push(initialDividerSize.attributes.usedProfile);
            }
            this.config.jsonConfig.dividerId = initialDividerSize.attributes.apiId;
        }
    }

    splitWindow(verticalSplits, horizontalSplits, apiObject, sashTypes, handle) {
        const levels = horizontalSplits === 0 ? 1 : 2;
        const ao = apiObject;
        let newDividerId = 0;
        let newSashId = 0;
        let index = sashTypes.filter(type => ['HS', 'PSK', 'OD', 'DK', 'DS'].includes(type)).length;
        const origIndex = index;
        const standardFields = this.windowDimensionsService.standardFields;
        const topLightFields = this.windowDimensionsService.topLightFields;
        const max = standardFields + topLightFields;
        for (let i = 0; i < max; i++) {
            let newDiv = false;
            const sashFunction =
                this.convertSashTypes(sashTypes, (i === (max - 1)), newSashId);
            let handleInner;

            if (sashFunction.id === this.config.sashTypes.F ||
                sashFunction.id === this.config.sashTypes.FF) {
                handleInner = {};
            } else {
                handleInner = handle;
            }

            const newSash = {
                id: newSashId,
                nearDividers: cloneDeep(this.config.jsonConfig.nearDividers),
                type: {
                    id: sashFunction.id,
                    handlePosition: sashFunction.handlePosition,
                    type: sashFunction.type
                },
                handleInner
            };
            if (origIndex === 2 && (
                    (this.orginalData.rules.window_door && ['DK', 'DS'].includes(sashTypes[i])) ||
                    (ao.type === 'folding_door' && sashTypes[i] === 'DK') || ['HS', 'PSK', 'OD'].includes(sashTypes[i])
                )) {
                newSash.index = this.orginalData.data[0].attributes.defaultInsideView ? index : origIndex - (index - 1);
                --index;
            }

            if (i !== topLightFields - 1 && i !== max - 1) {
                const newDivider = {
                    id: newDividerId,
                    dividerId: 1,
                    direction: 'vertical'
                };
                newSash.nearDividers.right = cloneDeep(newDivider.id);
                apiObject.dividers.push(cloneDeep(newDivider));
                newDividerId++;
                newDiv = true;
            }
            if (i !== 0 && i !== topLightFields && !newDiv) {
                newSash.nearDividers.left = cloneDeep(apiObject.dividers[newDividerId - 1].id);
            } else if (i !== 0 && i !== topLightFields && newDiv) {
                newSash.nearDividers.left = cloneDeep(apiObject.dividers[newDividerId - 2].id);
            }

            apiObject.sashes.push(cloneDeep(newSash));
            newSashId++;
        }

        if (levels === 2) {
            const newDivider = {
                id: newDividerId,
                dividerId: 1,
                direction: 'horizontal'
            };

            for (let i = 0; i < topLightFields; i++) {
                ao.sashes[i].nearDividers.bottom = newDivider.id;
            }
            for (let i = 0; i < standardFields; i++) {
                ao.sashes[i + topLightFields].nearDividers.top = newDivider.id;
            }

            apiObject.dividers.push(cloneDeep(newDivider));
        }
    }

    getInitialHandle() {
        const handleId = this.getInitialValueId('handle');

        return this.getHandle(handleId);
    }

    getHandle(handleId, side = 'inside') {
        const allHandles = this.getInitialOptions('handle');
        const currentHandle = find(allHandles, el => el.id === handleId);

        if (angular.isUndefined(currentHandle)) {
            return null;
        }
        const handleColorId = currentHandle.relationships.color.data.id;
        const handleColor = this.setColor(handleColorId, 'handle' + side.charAt(0).toUpperCase() + side.slice(1));

        return Object.assign({}, {
            id: currentHandle.attributes.apiId,
            color: handleColor
        });
    }

    setInitialSashesAndDividers(apiObject) {
        const ao = apiObject;
        const standardFields = this.data.data[0].attributes.standardFields;
        const topLightFields = this.data.data[0].attributes.topLightFields;
        const handle = this.getInitialHandle();
        if (topLightFields > 0) {
            this.windowDimensionsService.setLevel(2);
        }
        this.windowDimensionsService.setTopLightHeight(this.getInitialAttributes('topLightHeight'));
        const sashTypes = this.getSashTypes();

        ao.dividers = [];
        ao.sashes = [];

        this.splitWindow(standardFields, topLightFields, ao, sashTypes, handle);
    }

    getSashTypes() {
        let sashTypes = [];

        forEach(this.getInitialOptions('sash'), (el) => {
            sashTypes.push(el.attributes.type);
        });
        const initialActiveSashId = this.getInitialValueId('activeSash');
        const isSashesToConvert = sashTypes.length === 2 && sashTypes[0] === 'DK' && sashTypes[1] === 'DK';

        if (isSashesToConvert && initialActiveSashId === '1') {
            sashTypes = ['DS', 'DK'];
        } else if (isSashesToConvert && initialActiveSashId === '2') {
            sashTypes = ['DK', 'DS'];
        } else if (this.apiService.editSource && isSashesToConvert && initialActiveSashId === '3') {
            sashTypes = ['DS', 'DK'];
        }
        return sashTypes;
    }

    getInititialShape() {
        const shape = {};
        const width = this.getInitialAttributes('width');
        const height = this.getInitialAttributes('height');
        if (!this.getInitialOptions('shape')) {
            shape.h1 = height;
            shape.h3 = height;
            shape.s1 = width;
        } else {
            const shapeString = angular.fromJson(this.getInitialOptions('shape')[0].attributes);
            shape.h1 = parseInt(shapeString.h1, 10);
            shape.h2 = parseInt(shapeString.h2, 10);
            shape.h3 = parseInt(shapeString.h3, 10);
            shape.s1 = parseInt(shapeString.s1, 10);
            shape.s2 = parseInt(shapeString.s2, 10);
            shape.s3 = parseInt(shapeString.s3, 10);
            shape.d = parseInt(shapeString.d, 10);
            shape.shape = shapeString.shape;
            shape.type = shapeString.type;
        }

        return shape;
    }

    getInitialMuntins() {
        const muntins = {};
        const muntinsSizes = this.getInitialOptions('mullionSize');
        const selectedSize = find(muntinsSizes,
            el => el.id === this.getInitialValueId('mullionSize')
        );

        muntins.colorOuter = this.setColor(
            this.getInitialValueId('mullionColorOuter'),
            'mullionColorOuter'
        );
        muntins.colorInner = this.setColor(
            this.getInitialValueId('mullionColorInner'),
            'mullionColorInner'
        );
        if (angular.isDefined(selectedSize)) {
            muntins.size = String(parseInt(selectedSize.attributes.size, 10));
        } else {
            muntins.size = 0;
        }
        return Object.assign(this.config.jsonConfig.muntinsInfo, muntins);
    }

    getInitialSealColor() {
        const allSeals = this.getInitialOptions('seal');
        let seal = find(allSeals, ['id', this.getInitialValueId('seal')]);
        if (!seal) {
            seal = allSeals[0];
        }
        return {
            id: seal.attributes.apiId,
            isRAL: seal.attributes.isRal,
            isDefault: true
        };
    }

    getInitialAttributes(fieldName) {
        return this.data.data[0].attributes[fieldName];
    }

    getInitialValueId(fieldName) {
        const apiData = this.data.data[0];
        if (angular.isDefined(apiData.relationships[fieldName])) {
            return apiData.relationships[fieldName].data.id;
        }

        return null;
    }

    getInitialOptions(fieldName) {
        return this.data.included[fieldName];
    }

    setColor(currentColorId, fieldName) {
        const allColors = this.getInitialOptions('color');
        const selectedColor = find(allColors, ['id', currentColorId]);
        let initialColorId = this.getInitialValueId(fieldName);
        let isDefault = true;
        const initialColor = find(allColors,
            el => el.id === initialColorId
        );
        if (selectedColor && angular.isDefined(initialColor)) {
            isDefault = selectedColor.attributes.apiId === initialColor.attributes.apiId;
        }
        if (angular.isUndefined(selectedColor)) {
            return {
                id: -1,
                isRal: false,
                isDefault,
                color: 'ffffff',
            };
        }
        const color = {
            id: selectedColor.attributes.apiId ? selectedColor.attributes.apiId : selectedColor.id,
            isRAL: selectedColor.attributes.isRal,
            isDefault,
            color: selectedColor.attributes.hex.slice(1)
        };
        return color;
    }

    getInitialColors(obj) {
        const attrObj = obj;
        const colors = {};
        const colorsProperties = ['alushell', 'core', 'inner', 'outer'];

        forEach(colorsProperties, (el) => {
            const elId = this.getInitialValueId(el);

            if (elId) {
                colors[el] = this.setColor(elId, el);

                if (el === 'alushell') {
                    attrObj.hasAlushell = true;
                }
            } else {
                colors[el] = el === 'core' ? {} : null;
            }
        });

        attrObj.colors = {
            frame: colors,
            sash: colors
        };
    }

    getInitialAccesories() {
        const accessories = [];
        const initialAccesories = this.data.data[0].relationships.accessories.data;

        const allHandles = this.getInitialOptions('handle');
        const handleId = this.getInitialValueId('handle');
        const handle = find(allHandles, el => el.id === handleId);
        let handleAccessoryId = null;
        if (handle) {
            handleAccessoryId = find(allHandles, el =>
                el.id === handleId).attributes.accessory_api_id;
        }

        forEach(initialAccesories, (el) => {
            const accessory = this.createAccessory(el.id, false, el.color);

            accessories.push(accessory);
        });

        if (handleAccessoryId) {
            accessories.push(this.createAccessory(handleAccessoryId, false, null));
            this.windowDimensionsService.handleAccessoryId = handleAccessoryId;
        }

        return accessories;
    }

    createAccessory(id, isProfile, color) {
        const accessory = {
            amount: 0,
            count: 1,
            id: parseInt(id, 10)
        };

        accessory.color = {};
        accessory.color[isProfile ? 'profile' : 'accessory'] = angular.isDefined(color) ? color : {};

        return accessory;
    }
}

JsonBuilderService.$inject = [
    'config',
    'windowDimensionsService',
    'apiService',
];

export default angular.module('jsonBuilderService', [])
    .service('jsonBuilderService', JsonBuilderService)
    .name;